import React from 'react';
import { View, TouchableOpacity } from 'react-native';
import MyAppText from '../MyAppText';
import { translate } from '../../services/translate';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextMask } from 'react-native-masked-text';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { WindowInformation } from '../../services/window-information';
import Card from '../Card';
import { RootNavigation } from '../../Routes';
import { openInNewTab } from '../../services/navigation-assistant';

export function DefaultOccurrence({ occurrence, navigation }: { occurrence: Occurrence; navigation: RootNavigation; }) {
    const { styles, theme } = useStyles(styleSheet);
    const windowInfo = WindowInformation();

    if (occurrence.triggerType !== null) {
        return <></>;
    }

    return (
        <View style={{ gap: 20 }}>
            <View style={{ gap: 5 }}>
                <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', paddingBottom: 10 }}>
                    <View style={{ flexDirection: 'row', alignItems: 'center' }}>
                        <TouchableOpacity
                            onPress={() => {
                                if (occurrence.id) {
                                    openInNewTab('Dispatch', { screen: 'DispatchOccurrenceDetail', params: { occurrenceId: occurrence.id } });
                                }
                            }}
                            disabled={windowInfo.isMobile}
                        >
                            <MyAppText style={{ fontSize: 16, color: theme.colors.textColor, fontWeight: 'bold' }}>
                                {translate('nProtocol')}: {occurrence?.id}
                            </MyAppText>
                        </TouchableOpacity>
                        <MyAppText> </MyAppText>
                        <MyAppText style={{ fontSize: 14, color: theme.colors.card.detailText }}>
                            ({translate('team')} {translate(occurrence.OccurrenceUnits?.length && occurrence.OccurrenceUnits[0].OccurrenceUnit.isStarter ? 'starter' : 'support').toLowerCase()})
                        </MyAppText>
                    </View>
                    <TouchableOpacity onPress={() => navigation.navigate('AppAgent', { screen: 'AgentOccurrences' })}>
                        <FontAwesomeIcon color={theme.colors.iconColor} fontSize={30} icon={faTimes} />
                    </TouchableOpacity>
                </View>
                <MyAppText style={styles.alertText}>
                    {translate('occurrence')}:
                </MyAppText>
                <MyAppText style={styles.alertName}>{occurrence.occurrenceType?.name}</MyAppText>
            </View>
            <Card>
                <View>
                    <View style={styles.visualizedRow}>
                        <MyAppText style={styles.cardBoldText}>{translate('occurrenceId')}:</MyAppText>
                        <MyAppText style={styles.cardText}>{occurrence.id}</MyAppText>
                    </View>
                    <View style={styles.visualizedRow}>
                        <MyAppText style={styles.cardBoldText}>{translate('address')}:</MyAppText>
                        <MyAppText style={styles.cardText}>{occurrence.address}</MyAppText>
                    </View>
                    <View style={styles.visualizedRow}>
                        <MyAppText style={styles.cardBoldText}>{translate('requester')}:</MyAppText>
                        <MyAppText style={styles.cardText}>{occurrence.requester}</MyAppText>
                    </View>
                    <View style={styles.visualizedRow}>
                        <MyAppText style={styles.cardBoldText}>{translate('phone')}:</MyAppText>
                        <TextMask
                            style={{ color: theme.colors.textColor, fontFamily: 'Open Sans' }}
                            type={'cel-phone'}
                            value={occurrence.phone} />
                    </View>
                    <View style={styles.visualizedRow}>
                        <MyAppText style={styles.cardBoldText}>{translate('priority')}:</MyAppText>
                        <MyAppText style={[styles.cardText, occurrence.priority === 'maximum' ? { color: '#FF0027' } : undefined]}>{occurrence.priority ? translate(occurrence.priority) : ''}</MyAppText>
                    </View>
                    <View>
                        <View style={{ paddingBottom: 30 }}>
                            <MyAppText style={styles.cardBoldText}>{translate('narrative')}:</MyAppText>
                            <MyAppText style={styles.cardText}>{occurrence.narrative}</MyAppText>
                        </View>
                    </View>
                </View>
            </Card>
        </View>
    );
}


const styleSheet = createStyleSheet((theme) => ({
    alertText: {
        color: theme.colors.labelColor,
        fontSize: 16,
        fontWeight: 'bold',
    },
    alertName: {
        color: theme.colors.textColor,
        fontSize: 18,
        fontWeight: 'bold',
    },
    visualizedRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5
    },
    cardText: {
        color: theme.colors.labelColor,
        fontSize: 12
    },
    cardBoldText: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 14
    },
    plateInfoText: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 24
    }
}));
